import PropTypes from "prop-types";
import Pagination from "@shared/v2/Pagination";

const PaginationWrapper = ({ paginationInfo, onGoToPage }) => (
  <div role="navigation" aria-label="navigation" className="tw-flex tw-justify-center">
    <Pagination
      currentPage={paginationInfo.current_page}
      totalPages={paginationInfo.total_pages}
      onGoToPage={onGoToPage}
    />
  </div>
);

PaginationWrapper.propTypes = {
  paginationInfo: PropTypes.shape({
    current_page: PropTypes.number.isRequired,
    total_pages: PropTypes.number.isRequired,
  }).isRequired,
  onGoToPage: PropTypes.func.isRequired,
};

export default PaginationWrapper;
